import memoize from 'lodash/memoize';

import { StyledDropdownMenu } from '../filter-popover.styled';
import { ValueInputType } from './types';

/**
 * Returns a suitable dropdown input component for the given enum definition
 * from a column definition. Memoized by the enum definition, so subsequent
 * calls with the same enum definition object will return the same component.
 */
export const createEnumValueInput = memoize(
  (theEnum: { value: string; label: string }[]): ValueInputType =>
    // eslint-disable-next-line react/prop-types -- Lint bug: They're specified.
    function EnumValueInput({ onChange, value }): React.ReactElement {
      const valueString = value === null ? '' : String(value);
      return (
        <StyledDropdownMenu
          options={theEnum}
          value={valueString ?? undefined}
          onChange={(newValue: string): void => onChange(newValue)}
        />
      );
    },
);
